module.exports = __webpack_public_path__ + "static/img/cardMunicipio.317a1b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardMunicipio.png
// module id = SRkB
// module chunks = 11